import { Card, Col, Row } from 'antd'
import { ReactComponent as LiveLessonIcon } from '../../assets/Dashboard/live-lesson.svg'
import { UserSquareIcon } from 'hugeicons-react';

const TotalLiveLessons = (data: any) => {
    console.log(data)

    return (
        <Card className='border-radius-md'>
            <Row gutter={24} align={'middle'}>
                <Col>
                    <div className='d-flex p-16 border-radius-lg' style={{ background: '#663690' }}>
                        <UserSquareIcon color='white' />
                    </div>
                </Col>
                <Col span={18}>
                    <p className='m-0 font-color-gray fs-14 fw-500'>Toplam Canlı Ders</p>
                    <h3 className='m-0 font-color-dark-blue fs-24 fw-700'>{data?.data?.total ?? '0'}</h3>
                </Col>
            </Row>
        </Card>
    )
}

export default TotalLiveLessons